module.exports = __webpack_public_path__ + "img/01.8a211be3.png";